export const query_lastActivity_byUserId = `
query getLastActivityByUserId($tenantId: String!, $aziendaId: Int!, $userId: String!) {
    user_lastactivity(where: { TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}, UserId: {_eq: $userId}}) {
        Id
        TenantId
        AziendaId
        UserId
        Path
        EntityId
        EntityName
    }
}`;